import { useEffect, useState } from 'react';
import appConfigService from '../services/appConfigService.js';
import { getAndroidVersionCode, isNativeAndroid } from '../utils/nativeApp.js';

const parseVersionCode = (value) => {
  const parsed = parseInt(value, 10);
  return Number.isFinite(parsed) ? parsed : null;
};

export function useAppVersionCheck() {
  const [state, setState] = useState(() => ({
    status: isNativeAndroid() ? 'checking' : 'ok',
    currentVersionCode: null,
    minimumVersionCode: null,
    latestVersionCode: null,
    playStoreUrl: null,
    message: null,
  }));

  useEffect(() => {
    if (!isNativeAndroid()) {
      return undefined;
    }

    let cancelled = false;

    const checkVersion = async () => {
      try {
        const currentVersionCode = await getAndroidVersionCode();
        let config = null;

        try {
          config = await appConfigService.getMobileAppConfig();
        } catch (error) {
          console.warn('Mobile app config unavailable; version gate skipped.', error);
        }

        const envMinimum = parseVersionCode(process.env.REACT_APP_ANDROID_MIN_VERSION_CODE);
        const minimumVersionCode = parseVersionCode(config?.minimum_android_version_code) ?? envMinimum;
        const latestVersionCode = parseVersionCode(config?.latest_android_version_code);
        const playStoreUrl = config?.play_store_url || null;
        const message = config?.update_message || null;

        const updateRequired = (
          minimumVersionCode != null
          && currentVersionCode != null
          && currentVersionCode < minimumVersionCode
        );

        if (!cancelled) {
          setState({
            status: updateRequired ? 'update_required' : 'ok',
            currentVersionCode,
            minimumVersionCode,
            latestVersionCode,
            playStoreUrl,
            message,
          });
        }
      } catch (error) {
        console.warn('Version check failed; allowing app access.', error);
        if (!cancelled) {
          setState((previous) => ({ ...previous, status: 'ok' }));
        }
      }
    };

    checkVersion();

    return () => {
      cancelled = true;
    };
  }, []);

  return state;
}
